module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-tab tools-tab-tags"
  }, [_c('span', [_vm._v("Project toewijzen aan deze Dienst")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("Current Project: " + _vm._s(_vm.selectedProject ? _vm.selectedProject.name : 'None'))]), _vm._v(" "), (_vm.projects && _vm.projects.length) ? _c('ul', {
    staticClass: "list list-tags"
  }, _vm._l((_vm.projects), function(project) {
    return _c('li', {
      key: project.id,
      class: {
        'is-active': _vm.isSelected(project)
      },
      on: {
        "click": function($event) {
          return _vm.handleSelection(project)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(project.name) + "\n                "), _c('span', {
      staticStyle: {
        "font-size": "12px !important",
        "font-style": "italic !important"
      }
    }, [_vm._v("\n                    (" + _vm._s(project.code) + ")\n                ")])]), _vm._v(" "), (_vm.isSelected(project)) ? _c('icon', {
      attrs: {
        "name": "cancel"
      }
    }) : _c('icon', {
      attrs: {
        "name": "check"
      }
    })], 1)
  }), 0) : _c('div', {
    staticClass: "empty"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('page.roster.tools.projects_none')) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe279ace","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/tools/Project.vue
// module id = 604
// module chunks = 234